module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Regular.e079b169.woff";